import React, { useEffect, useMemo, useState } from "react";
import cookie from 'react-cookies';
import { batch, shallowEqual, useDispatch, useSelector } from "react-redux";
import APIS from "../common/APIs";
import CommonUtil from "../common/CommonUtil";
import Constants from "../common/Constants";
import { BETSLIP_TABS } from "../common/Foundation";
import BetslipHelper from "../components/CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper";
import MemberServices from "../services/MemberService";
import { addOddsSelection, updateBetslipTabState } from "../slices/BetslipSlice";
import { updateHasDynamicParameter } from "../slices/SportsSlice";
import useGetBetLocationTracking from "../hooks/useGetBetLocationTracking"


const IframeHOC = Component => props => {
    const enableDP = window.env.dynamicParameterIframeUrl && window.env.enableDynamicParameter;
    const options = useSelector(state => state.SportsSlice.options, shallowEqual);
    const user = useSelector(state => state.AccountsSlice.user);
    const isHasDynamicParameter = useSelector(state => state.SportsSlice.isHasDynamicParameter);
    const dispatch = useDispatch();
    const { helpPageUrl } = useSelector(state => state.LayoutTemplateSlice.templateData.attributes);
    const dynamicParameterUrl = useMemo(() => APIS.getDPIframeURL(`v=${new Date().getTime()}`), [enableDP]);
    const [renderIframe, setRenderIframe] = useState(false);
    const getBetLocationTracking = useGetBetLocationTracking({isGetDefaultPeriodDesc: true});
    useEffect(() => {
        dispatch(updateHasDynamicParameter(!enableDP));
        enableDP && pingToDPIframe();
    }, [])

    useEffect(() => {
        const timer = renderIframe && setTimeout(handleDynamicParameterError, window.env.dynamicParameterTimeout);
        return () => {
            timer && clearTimeout(timer);
        };
    }, [renderIframe, isHasDynamicParameter])

    useEffect(() => {
        window.listenEvent("message", handleListenMessage)
        return () => {
            window.stopListenEvent('message', handleListenMessage);
        }
    }, [user.auth, options.oddsFormat]);

    function handleListenMessage(event) {
        if (!event || !event.data) return;
        //simplified standard
        let msgCode = event.data.msgCode;
        let msgData = event.data.msgData;
        //dynamic parameter standard
        if (CommonUtil.isJsonString(event.data)) {
            const obj = JSON.parse(event.data);
            msgCode = obj.type;
            msgData = obj.data;
        }
        switch (msgCode) {
            case Constants.IFRAME_MESSAGE.DP:
                handleDynamicParameter(msgData);
                break;
            case Constants.IFRAME_MESSAGE.SELECTION_INFO:
                if (user.auth) {
                    (msgData || []).forEach((item, index) => {
                        const selection = BetslipHelper.buildSelectionFromIframe(item, options.oddsFormat);
                        selection.betLocationTracking = getBetLocationTracking(event, true); 
                        batch(() => {
                            dispatch(updateBetslipTabState(BETSLIP_TABS.SINGLE));
                            dispatch(addOddsSelection(selection));
                        });
                    });
                }
                break;
            case Constants.IFRAME_MESSAGE.OPEN_CONTACT_US:
                let contactUrl = helpPageUrl.replace('{lang}', CommonUtil.getHelpPageLocaleURL(CommonUtil.getCurrentLang()));
                if (user.auth) {
                    contactUrl += ('&cid=' + user.loginId);
                }
                window.open(`${contactUrl}#contact`);
                break;
            default:
                break;
        }
    }

    /**
    * Handle dynamic parameter from iframe
    */
    const handleDynamicParameter = (data) => {
        const { name, value } = data;
        const previousDynamicParam = localStorage.getItem("_dp");
        if (previousDynamicParam !== name) {
            cookie.remove(previousDynamicParam, { path: '/', domain: CommonUtil.getSubDomain() });
        }
        CommonUtil.saveCookie(name, value, { path: '/', domain: CommonUtil.getSubDomain() });
        localStorage.setItem("_dp", name);
        dispatch(updateHasDynamicParameter(true))
    }

    /**
    * Handle case of dynamic parameter do not post message
    * If page needs dynamic parameter to call service, eg: odds page
    */
    const handleDynamicParameterError = () => {
        if (isHasDynamicParameter || !Constants.DP_CONTAINER.includes(props.pageContainer))
            return;
        dispatch(updateHasDynamicParameter(true));
        MemberServices.updateReasonDPFailed({ reason: Constants.DP_ERROR.NO_RECEIVE_DP_MESSAGE });
    }
    
    const pingToDPIframe = () => {
        MemberServices.pingToDPIframe()
            .then(res => {
                setRenderIframe(true);
            })
            .catch(error => {
                const reason = error.response ? error.response.statusText : '';
                dispatch(updateHasDynamicParameter(true));
                MemberServices.updateReasonDPFailed({ reason });
            });
    }
    

    return (
        <React.Fragment>
            <Component {...props} />
            {renderIframe && <iframe src={dynamicParameterUrl} className="dp-iframe"></iframe>}
        </React.Fragment>
    );

};

export default IframeHOC;


// WEBPACK FOOTER //
// ./src/app/decorator/IframeHOC.js